import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface SectionTitleProps {
  children: string;
  className?: string;
}
export const SectionTitle = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("text-center font-800 typo-h4", "mobile-tablet:font-700 mobile-tablet:typo-body2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h2 className={t1}>{children}</h2>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};